exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".checkout-loader{display:block;margin:0 auto;margin-top:50px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/TruValidate/TruValidate.scss
// module id = 913
// module chunks = 0